/**
 * Console product name for the former Cost monitoring / reporting domain.
 * Used in sidebars, product picker (reporting-limited), search, bookmarks.
 */
export const RADAR_NAV_TITLE = 'Radar';

/** @deprecated Prefer {@link RADAR_NAV_TITLE}; kept for seeded bookmark migration. */
export const COST_MONITORING_NAV_TITLE = 'Cost monitoring';
